export { SegmentedControl } from './SegmentedControl';
export type { Props } from './SegmentedControl.types';
